import React, { Component } from 'react';
import './LabeledStatsContainer.scss';
import { InfoTooltip } from '../../../../shared/info-tooltip/InfoTooltip';

export class LabeledStatsContainer extends Component {
    render = () => {
        const { label, tooltipMessage, children } = this.props;

        return (
            <div className={'labeled-stats-container'}>
                <span>
                    {label}{' '}
                    {tooltipMessage && <InfoTooltip message={tooltipMessage} />}
                </span>
                {children}
            </div>
        );
    };
}
